import { render } from "./Success.vue?vue&type=template&id=ddad92b6&scoped=true"
import script from "./Success.vue?vue&type=script&lang=js"
export * from "./Success.vue?vue&type=script&lang=js"

import "./Success.vue?vue&type=style&index=0&id=ddad92b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddad92b6"]])

export default __exports__